export default [
  {
    src: "/img/hakkimizda/kamera-1.jpg",
    alt: "Güvenlik Kamera Sistemi",
    caption: "Güvenlik Kamera Sistemi",
    width: 532,
    height: 500
  },
  {
    src: "/img/hakkimizda/kamera-2.jpg",
    alt: "Güvenlik Kamera Sistemi",
    caption: "Güvenlik Kamera Sistemi",
    width: 532,
    height: 709
  },
  {
    src: "/img/hakkimizda/kamera-3.jpg",
    alt: "Güvenlik Kamera Sistemi",
    caption: "Güvenlik Kamera Sistemi",
    width: 532,
    height: 517
  },
  {
    src: "/img/hakkimizda/kamera-4.jpg",
    alt: "Güvenlik Kamera Sistemi",
    caption: "Güvenlik Kamera Sistemi",
    width: 532,
    height: 725
  },
  {
    src: "/img/hakkimizda/khoja.jpeg",
    alt: "Karton Kutu Ambalaj",
    caption: "Karton Kutu Ambalaj",
    width: 532,
    height: 619
  },
  {
    src: "/img/hakkimizda/bal.jpeg",
    alt: "Karton Kutu Ambalaj",
    caption: "Karton Kutu Ambalaj",
    width: 532,
    height: 596
  },
  {
    src: "/img/hakkimizda/ramazan.jpeg",
    alt: "Karton Kutu Üretim",
    caption: "Karton Kutu Üretim",
    width: 532,
    height: 709
  },
  {
    src: "/img/hakkimizda/ugurcup.jpeg",
    alt: "Hediyelik Kutu Ambalaj",
    caption: "Hediyelik Kutu Ambalaj",
    width: 532,
    height: 709
  },
  {
    src: "/img/hakkimizda/corek.jpeg",
    alt: "Karton Kutu Üretim",
    caption: "Karton Kutu Üretim",
    width: 532,
    height: 619
  }
];
